var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52733 3.6543C4.58757 3.6543 3 5.24183 3 7.18162V18.1275C3 20.0673 4.58754 21.6543 6.52733 21.6543H17.4732C19.413 21.6543 21 20.0673 21 18.1275V7.18162C21 5.24187 19.413 3.6543 17.4732 3.6543H6.52733ZM7.4145 6.62466C8.34457 6.62466 8.91746 7.23523 8.93514 8.03783C8.93514 8.8227 8.34454 9.45044 7.39651 9.45044H7.37906C6.46669 9.45044 5.87699 8.82274 5.87699 8.03783C5.87699 7.23525 6.48454 6.62466 7.41448 6.62466H7.4145ZM15.4294 10.3759C17.2181 10.3759 18.559 11.545 18.559 14.0573V18.7475H15.8407V14.3718C15.8407 13.2722 15.4473 12.5221 14.4635 12.5221C13.7125 12.5221 13.2649 13.0277 13.0683 13.5161C12.9965 13.6909 12.9789 13.9349 12.9789 14.1794V18.7475H10.2606C10.2606 18.7475 10.2962 11.3352 10.2606 10.5677H12.9795V11.726C13.3407 11.1687 13.9869 10.3759 15.4294 10.3759V10.3759ZM6.03733 10.5683H8.75567V18.7475H6.03733V10.5683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.fe9d96aa0b947be1eddbfa75b4f79ff5.svg";
export { ForwardRef as ReactComponent };